import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FileText, FolderOpen, Search, Calendar } from 'lucide-react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/shadcn-ui/sheet';
import { Button } from '@/components/shadcn-ui/button';
import { cn } from '@/lib/utils';

const MobileSidebar = ({ open, onOpenChange }) => {
  const location = useLocation();

  const navItems = [
    { path: '/citypermit/chat', label: 'New permit', icon: FileText },
    { path: '/citypermit/projects', label: 'Projects', icon: FolderOpen },
    { path: '/citypermit/search-now', label: 'Search now', icon: Search },
  ];

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="w-72 p-0">
        <SheetHeader className="p-4 border-b border-border text-left">
          <SheetTitle className="flex items-center gap-2">
            <img src="/logo.png" alt="Logo" className="w-8 h-8" />
            <span className="text-xl font-medium text-white font-baloo-2">Zermit AI</span>
          </SheetTitle>
        </SheetHeader>

        {/* Navigation */}
        <nav className="flex-1 p-4">
          <ul className="flex flex-col gap-2">
            {navItems.map(item => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;

              return (
                <li key={item.path}>
                  <Button
                    asChild
                    variant={isActive ? 'secondary' : 'ghost'}
                    className={cn(
                      'w-full justify-start gap-3 h-auto py-3',
                      isActive && 'bg-primary/10 text-primary font-medium hover:bg-primary/15',
                      !isActive && 'text-muted-foreground hover:text-foreground'
                    )}
                    onClick={() => onOpenChange(false)}
                  >
                    <Link to={item.path}>
                      <Icon size={20} />
                      <span>{item.label}</span>
                    </Link>
                  </Button>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* Footer */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-border">
          <div className="flex items-center gap-3 px-4 py-3 text-muted-foreground text-sm">
            <Calendar size={20} />
            <span>123 Example St, Glendale</span>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default MobileSidebar;
